<ng-container *ngIf="pageLink">
  <div
    class="link"
    fxLayoutAlign="space-between center"
    [ngClass]="{ 'link--details': detailsLink }"
    (click)="
      pageLink.refreshBalanceLink
        ? refreshBalance()
        : pageLink.prepaidLink
        ? prepaidIban()
        : pageLink.savingsLink
        ? setSavingsRoute()
        : pageLink.savingsOrderLink
        ? setSavingsOrderRoute()
        : additionalNavigationActions()
    "
    [routerLink]="pageLink.route"
    [routerLinkActive]="
      pageLink.route ? (detailsLink ? 'active-details' : 'active') : ''
    "
  >
    <div
      fxLayoutAlign="start center"
      [fxLayoutGap]="detailsLink ? '25px' : '14px'"
    >
      <div class="link__icon" *ngIf="pageLink.icon">
        <img
          width="15"
          src="assets/images/page-link/{{ pageLink.icon }}.svg"
          alt="details"
        />
        <div *ngIf="redDot" class="red-dot"></div>
      </div>
      <div>
        <p [ngClass]="{ 'font-semiBold': detailsLink }">
          {{ pageLink.name | translate }}
        </p>
        <p class="font-13" [ngClass]="descriptionColor">
          {{ pageLink.description | lowercase }}
        </p>
      </div>
    </div>
    <img *ngIf="pageLink.route"
      src="assets/images/page-link/{{
        detailsLink ? 'arrow_lightblue' : 'arrow_white'
      }}.svg"
      alt="arrow"
    />
  </div>
</ng-container>
